// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"3f11b3f6","106":"43733832","126":"dd848015","453":"e7717438","494":"4a5f7404","522":"257e8cf0","545":"501dcfec","607":"075f2de2","610":"d11af1f3","653":"99ae335d","837":"93855d5f","867":"dc27eb16","947":"104b642c","972":"dba28392"}[chunkId] + ".chunk.js";
};